import React from 'react';

export default function ChapterList() {
  const Chapters = [
    {
      chapterSeq: 'Chapter 1',
      chapterName: 'Introduction To The Contents',
    },
    {
      chapterSeq: 'Chapter 2',
      chapterName: 'The Tests: IELTS, GRE and GMAT',
    },
    {
      chapterSeq: 'Chapter 3',
      chapterName: 'College and Visa Applications',
    },
    {
      chapterSeq: 'Chapter 4',
      chapterName: 'Booking your GIC',
    },
    {
      chapterSeq: 'Chapter 5',
      chapterName: 'Booking your Medical Assessment',
    },
    {
      chapterSeq: 'Chapter 6',
      chapterName: 'Loan Applications',
    },
    {
      chapterSeq: 'Chapter 7',
      chapterName: 'Visa Applications',
    },
    {
      chapterSeq: 'Chapter 8',
      chapterName: 'COVID and Pre-departure',
    },
    {
      chapterSeq: 'Chapter 9',
      chapterName: 'Departure & Landing Experience',
    },
    {
      chapterSeq: 'Chapter 10',
      chapterName: 'FAQs and useful tools',
    },
  ];

  const ChapterRow = ({ chapterSeq, chapterName }) => {
    return (
      <div
        key={chapterName}
        className="w-5/6 max-w-xl pt-4 pb-4 pl-8 pr-8 m-auto transition-all duration-200 bg-white shadow-sm cursor-pointer lg:-auto lg:w-1/2 font-brand hover:shadow-md"
      >
        <p className="text-xs uppercase"> {chapterSeq} </p>
        <h2 className="text-lg font-bold text-gray-900 lg:text-2xl"> {chapterName} </h2>
      </div>
    );
  };

  return (
    <>
      <h1 className="mt-12 text-2xl font-bold text-center text-gray-800 lg:text-4xl"> We'll guide you through </h1>

      <div className="flex flex-col justify-center m-auto mt-12 space-y-2 lg:space-y-8 ">
        {Chapters.map((chapter, i) => (
          <div key={i}>
            <ChapterRow chapterSeq={chapter.chapterSeq} chapterName={chapter.chapterName} />
          </div>
        ))}
      </div>
    </>
  );
}
